import script from "./DatePickerCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePickerCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./DatePickerCarousel.vue?vue&type=style&index=0&id=339eaf51&lang=scss"

const __exports__ = script;

export default __exports__